import { FC } from "preact/compat";
import { PulseProps } from "./interfaces";
import cn from "classnames";

const Pulse: FC<PulseProps> = ({ className, color = "violet" }) => (
    <>
        <div
            className={cn(
                "absolute w-4 h-4 opacity-75 inline-flex rounded-full animate-ping -right-2 -top-2 z-[200]",
                color === "violet" && "bg-violet-900",
                color === "amber" && "bg-amber-300",
                className,
            )}
        />
        <div
            className={cn(
                "w-4 h-4 absolute z-[200] -right-2 -top-2 flex border-2 p-[2px] items-center rounded-full justify-center",
                color === "violet" && "border-violet-900",
                color === "amber" && "border-amber-300",
                className,
            )}
        >
            <div
                className={cn(
                    "w-full h-full rounded-full",
                    color === "violet" && "bg-violet-900",
                    color === "amber" && "bg-amber-300",
                )}
            />
        </div>
    </>
);

export default Pulse;
